import React, { useState, useEffect, useRef } from "react";
import { Card, CardMedia, CardContent, Typography, IconButton, Grid } from "@mui/material";
import { ModalViewProduct } from "./Modal_view_product";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { ImagenesGlobal } from "../global/ImagenesGlobal";

//--card-size-diferent

const ProductosCarruselLargo = ({
	showTitle = "",
	allProducts = [],
	openModal,
	discountPercentage = 0,
	sizeCardName = '--cards-img-size',
	loadImageS,
	convertPrice = (() => { }),
}) => {
	const [itsActive, setItsActive] = useState(false);
	const reducedList = allProducts.slice(0, 15);

	const containerRef = useRef(null);
	const [stateImg, setStateImg] = useState(false);

	const [posIndex, setPosIndex] = useState(0);

	const returnTotalCards = () => {
		const containerSize = containerRef.current?.getBoundingClientRect();

		if (!containerSize) return;

		const totalCards = parseFloat(parseFloat(containerSize.width) / (returnSizeCards())).toFixed(0);

		return totalCards;
	}

	function controlSlider(decision = true) {
		setPosIndex((valor) => {
			const toca = decision ? (valor + 1) : (valor <= 0 ? 0 : (valor - 1));
			const currentCard = parseInt(returnTotalCards()) + parseInt(toca);

			return currentCard > reducedList.length ? 0 : toca;
		});
	}

	const returnSizeCards = () => {
		const root = document.documentElement;
		const estilos = getComputedStyle(root);
		const size_card = estilos.getPropertyValue(sizeCardName);
		const size_converted = parseInt(size_card) + 20;

		return size_converted;
	}

	useEffect(() => {
		let observer;
		if (reducedList.length > 0) {
			observer = new IntersectionObserver(([entry]) => {
				setItsActive(entry.isIntersecting);
			},
				{
					root: null, // Observe the viewport
					rootMargin: "0px", // Se puede ajustar para dar margen
					threshold: 1, // El porcentaje del elemento visible (en este caso, 50%)
				});

			if (containerRef.current) {
				observer.observe(containerRef.current);
			}
		}


		return () => {
			if (reducedList.length > 0 && containerRef.current) {
				observer.unobserve(containerRef.current);
			}
		};
	}, [reducedList]);

	useEffect(() => {
		let timer;
		if (itsActive) {
			timer = setInterval(() => {
				controlSlider();
			}, 3600);
		} else {
			clearInterval(timer);
		}

		if (!stateImg) {
			const myFather = containerRef.current?.parentElement?.parentElement?.parentElement;
			if (myFather) setStateImg(window.getComputedStyle(myFather)?.display == "block" ? true : false);
		}

		return () => {
			clearInterval(timer);
		};
	}, [itsActive]);


	return (
		<div className="container-prod-lg">
			{
				showTitle && (<h2>
					{showTitle}
				</h2>)
			}

			{/* <div className="slider-lg" style={{ transform: `translateX(-${posIndex * (posIndex <= 1 ? 258 : (246 - (0.2 * (posIndex<=10?posIndex:0))))}px)` }}> */}
			<div className="slider-lg" ref={containerRef}>
				<ul className="slider-main" style={{ transform: itsActive ? `translateX(-${posIndex * returnSizeCards()}px)` : '' }}>
					{
						reducedList && reducedList.length > 0 ? (
							reducedList.map((obj) => (
								<li className="global-card-prod"
									style={{
										width: `var(${sizeCardName})`,
										margin: '7px'
									}}
									onClick={() => openModal(obj)}
								>
									<div className="img-prod" style={{
										borderBottomLeftRadius: sizeCardName != '--cards-img-size' ? 'inherit' : 'none',
										borderBottomRightRadius: sizeCardName != '--cards-img-size' ? 'inherit' : 'none'
									}}>
										<ImagenesGlobal url={obj.img_list[0]} type={'picture'} loadImageS={loadImageS} />
									</div>
									{
										sizeCardName == '--cards-img-size' && (
											<CardContent
												sx={{
													"boxShadow": "none",
												}}
												style={{
													display: "flex",
													alignItems: "flex-start",
													justifyContent: "space-between",
													padding: '5px 10px',
												}}

											>
												<Typography
													variant="body2"
													style={{
														fontWeight: "bold",
														fontSize: "0.8rem",
														textAlign: "left",
														display: "-webkit-box",
														WebkitLineClamp: 2,
														WebkitBoxOrient: "vertical",
														overflow: "hidden",
														textOverflow: "ellipsis",
														lineHeight: "1.2em",
														height: "2.4em",
														flex: 1,
														color: '#000'
													}}
													title={obj.product_name}>
													{obj.product_name}
												</Typography>

												{discountPercentage > 0 ? (
													<div style={{ textAlign: "right", display: "flex", flexDirection: "column" }}>
														<Typography
															variant="caption"
															sx={{ fontSize: "0.7rem", textDecoration: "line-through", color: "#999" }}
														>
															{convertPrice(obj.sale_price, obj?.currency)}
														</Typography>
														<Typography
															variant="caption"
															color="green"
															sx={{ fontSize: "0.75rem", fontWeight: 600 }}
														>
															{(convertPrice(obj.sale_price) * (1 - discountPercentage / 100), obj?.currency)}
														</Typography>
													</div>
												) : (
													<Typography
														variant="caption"
														color="green"
														sx={{ fontSize: "0.75rem", fontWeight: 600, whiteSpace: "nowrap" }}
													>
														{convertPrice(obj.sale_price, obj?.currency)}
													</Typography>
												)}
											</CardContent>
										)
									}
								</li>
							))
						) : (<p>Empresa seleccionada no cuenta con productos registrados...</p>)
					}
				</ul>
			</div>

			{
				reducedList.length > returnTotalCards() && (
					<div className="control-list">
						<IconButton className="icons-modal-p" onClick={() => controlSlider(false)} sx={{ height: 'calc(5px + var(--size-icon))', width: 'calc(5px + var(--size-icon))' }}>
							<NavigateBeforeIcon sx={{ color: '#000' }} style={{ fontSize: 'var(--size-icon)' }} />
						</IconButton>

						<IconButton className="icons-modal-p" onClick={() => controlSlider(true)} sx={{ height: 'calc(5px + var(--size-icon))', width: 'calc(5px + var(--size-icon))' }}>
							<NavigateNextIcon sx={{ color: '#000' }} style={{ fontSize: 'var(--size-icon)' }} />
						</IconButton>
					</div>
				)
			}
		</div>
	);
};

export default ProductosCarruselLargo;


